// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"272c3739","453":"b073eb33"}[chunkId] + ".chunk.js";
};